import type { Item } from 'src/sdk/checkout/data/types'
// Função para verificar se o seguro cobre o valor da bike
export function priceRangeCoversBike(referenceId: string, bikePrice: number) {
  // Exemplo de referenceId: "100000-229999-C"
  const match = referenceId?.match(/^(\d+)-(\d+)-/)

  if (!match) {
    return false
  }

  const min = Number(match[1])
  const max = Number(match[2])
  const bikePriceCents = Math.round(bikePrice * 100)

  return bikePriceCents >= min && bikePriceCents <= max
}

/**
 * Função para identificar se um item é uma bike
 */
export const isBikeItem = (item: Item): boolean => {
  return (
    item.category === 'Equipamentos/Bicicletas' ||
    item.categoryName === 'Bicicletas' ||
    (Array.isArray(item.categoryTree) &&
      item.categoryTree.includes('Bicicletas'))
  )
}
